import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsArray, IsNotEmpty, IsOptional, IsString, ArrayUnique, IsInt } from 'class-validator';
import { Type } from 'class-transformer';

export class CreateChapterDto {
  @ApiProperty({ description: 'The title of the chapter', example: 'Quarterly Updates' })
  @IsNotEmpty()
  @IsString()
  title: string;

  @ApiPropertyOptional({ description: 'Array of newsfeed IDs to include in this chapter', example: [1, 2, 3], type: [Number] })
  @IsOptional()
  @IsArray()
  @ArrayUnique()
  @IsInt({ each: true })
  @Type(() => Number)
  newsfeeds?: number[];
}
